import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import CustomInput from '../../components/inputs/CustomInput'
import CustomDialog from '../../components/layouts/common/CustomDialog';
import { CenteredBox } from '../../components/layouts/OneViewBox';
import { APP_TYPES } from '../../utils/constants';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const VersionCreateUi = ({ title, isUpdate, fields, setFields, loading, onSubmit, isModal, handleAreaModalClose }) => {
    return (
        <>
            {!isModal &&
                <CustomDialog
                    id={`${isUpdate ? "edit" : "version"}`}
                    loading={loading}
                    err={fields?.err}
                    onSubmit={onSubmit}
                    title={`${isUpdate ? "Update" : "Create"} ${title}`}
                    closeText="Close"
                    confirmText={`${isUpdate ? "Update" : "Create"}`}
                >
                    {loading ? (
                        <CenteredBox><CircularProgress /></CenteredBox>
                    ) : (
                        <>
                            <CustomInput
                                autoFocus={true}
                                disabled={loading}
                                value={fields?.name}
                                onChange={(e) => setFields({ ...fields, err: '', name: e.target.value })}
                                type="text"
                                label={"Version Name*"}
                            />
                            <CustomInput
                              
                                disabled={loading}
                                value={fields?.main_version}
                                onChange={(e) => setFields({ ...fields, err: '', main_version: e.target.value })}
                                type="text"
                                label={"Main Version*"}
                            />
                            <CustomInput
                             
                                disabled={loading}
                                value={fields?.sub_version}
                                onChange={(e) => setFields({ ...fields, err: '', sub_version: e.target.value })}
                                type="text"
                                label={"Sub Version*"}
                            />
                            <Box>
                                <FormControl fullWidth margin="dense">
                                    <InputLabel>App Type*</InputLabel>
                                    <Select
                                        label={"App Type*"}
                                        name="app_type"
                                        value={fields.app_type || ""}
                                        onChange={(e) =>
                                            setFields({
                                                ...fields,
                                                err: "",
                                                app_type: e.target.value,
                                            })
                                        }
                                    >
                                        <MenuItem value={APP_TYPES.WEB}>Web</MenuItem>
                                        <MenuItem value={APP_TYPES.APP}>APP</MenuItem>
                                    </Select>
                                </FormControl>
                                <Box sx={{ minHeight: 250, mt: 2, border: '1px solid #ccc', background: '#fafafa', p: 1 }}>
                            
              <CKEditor
                config={{
                  placeholder: "Write Version Description...",
                  style: { height: "500px", minHeight: "500px" },
                  toolbar: { items: ['p', 'heading', 'italic', 'bold', 'blockquote', 'link', 'table', 'undo', 'redo', 'numberedList', 'bulletedList'] }

                }}
                name="description"
                id="description"

                disabled={loading}
                editor={ClassicEditor}

                onInit={(editor) => {


                }}
                data={fields.description}
                onReady={(editor) => {

                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "200px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
                onChange={(event, editor) => {
                  const data = editor.getData()
                  setFields({ ...fields, err: '', description: data })
                }}
                onBlur={(event, editor) => { }}
                onFocus={(event, editor) => { }}
              />
        
                                    
                                </Box>
                            </Box>
                        </>
                    )}
                </CustomDialog>
            }
        </>
    )
}

export default VersionCreateUi